import { Extension } from '@tiptap/core';
import { gapCursor } from 'prosemirror-gapcursor';

const Gapcursor = Extension.create({
    name: 'gapCursor',
    addProseMirrorPlugins() {
        return [
            gapCursor(),
        ];
    },
});

export default Gapcursor;
export { Gapcursor };
//# sourceMappingURL=tiptap-extension-gapcursor.esm.js.map
